import React from 'react';
import { MODULES } from '../../common/constants';
import PageHeader from '../../components/PageHeader';
import PreviewBar from '../component/Previewbar';
import LayoutRow from '../component/layout/LayoutRow';
import LeftPanel from '../pages/component/pageModules/LeftPanel';
import PreviewWrapper from '../pages/component/pageModules/Preview';
import EditPageProvider from '../pages/context/EditPageProvider';
import PreviewPageProvider from '../pages/context/PreviewPageProvider';
import TemplateRightPanel from './component/TemplateRightPanel';

const EditPageTemplate = () => {
  return (
    <>
      <PageHeader menu={MODULES?.UI_CONFIGURATION} />
      <div className="page-wrapper">
        <div className="page-wrapper-body edit-page">
          <LayoutRow>
            <LeftPanel />
            <TemplateRightPanel />
            <PreviewBar>
              <PreviewWrapper />
            </PreviewBar>
          </LayoutRow>
        </div>
      </div>
    </>
  );
};

const wrapper = () => {
  return (
    <PreviewPageProvider>
      <EditPageProvider isTemplate>
        <EditPageTemplate />
      </EditPageProvider>
    </PreviewPageProvider>
  );
};

export default wrapper;
